"use strict";

var _classCallCheck = require("/Users/bhautik/Project/macrometa/demo-crypto-trading-5g/crypto-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/bhautik/Project/macrometa/demo-crypto-trading-5g/crypto-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Streamapps = /*#__PURE__*/function () {
  function Streamapps(connection, appName) {
    _classCallCheck(this, Streamapps);

    this._connection = connection;
    this.name = appName;
  }

  _createClass(Streamapps, [{
    key: "retriveApplication",
    value: function retriveApplication() {
      return this._connection.request({
        method: "GET",
        path: "/_api/streamapps/".concat(this.name)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "updateApplication",
    value: function updateApplication(regions, appDefinition) {
      return this._connection.request({
        method: "PUT",
        path: "/_api/streamapps/".concat(this.name),
        body: JSON.stringify({
          "definition": appDefinition,
          "regions": regions
        })
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "deleteApplication",
    value: function deleteApplication() {
      return this._connection.request({
        method: "DELETE",
        path: "/_api/streamapps/".concat(this.name)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "activateStreamApplication",
    value: function activateStreamApplication(active) {
      return this._connection.request({
        method: "PATCH",
        path: "/_api/streamapps/".concat(this.name, "/active?active=").concat(active)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "query",
    value: function query(_query) {
      return this._connection.request({
        method: "POST",
        path: "/_api/streamapps/query/".concat(this.name),
        body: {
          "query": _query
        }
      }, function (res) {
        return res.body;
      });
    }
  }]);

  return Streamapps;
}();

exports.Streamapps = Streamapps;